import Card from "@components/clientCard/Card"
import { getCompanyLogo } from "@helpers/getCompanyLogo"
import { useAppDispatch } from "@redux/app/hooks"
import { setCurrentCompany } from "@redux/features/currentCompany/currentCompanySlice"
import { Link } from "@tanstack/react-router"
import { ReactElement } from "react"

const LIST_OF_COMPANY_FLAGS = {
	"Equinor Brasil": "Brasil",
	"Solstad Demo": "Demo",
	"Vard Demo": "Demo",
}

type ClientCardProps = {
	client: string
	isAllAssets?: boolean
}
export function ClientCard({ client, isAllAssets = false }: ClientCardProps): ReactElement {
	const dispatch = useAppDispatch()

	return (
		<div
			className="inline-block h-75"
			style={{ height: "250px" }}
			onClick={() => {
				dispatch(setCurrentCompany(client))
			}}
		>
			<Link to={`${client}${isAllAssets ? ":All" : ""}`}>
				{/* <Link to={`${replaceNorwegianVowels(client)}${isAllAssets ? ":All" : ""}`}> */}
				<Card
					width={"100%"}
					height={"100%"}
					padding={"0px"}
					isButton={true}
				>
					<div className="relative h-full w-full">
						{getCompanyLogo(client)}
						{isAllAssets && (
							<h4 className="absolute top-3/4 w-full text-center">{"All Assets"}</h4>
						)}
						{LIST_OF_COMPANY_FLAGS[client] !== undefined ? (
							<div
								className={`text-body shadow-card bg-dipai-secondary-800 absolute top-[calc(53px-20px)] -right-[calc(100px-53px)] flex h-10 w-50 origin-center rotate-45 items-center justify-center font-bold text-white`}
							>
								<p>{LIST_OF_COMPANY_FLAGS[client]}</p>
							</div>
						) : null}
					</div>
				</Card>
			</Link>
		</div>
	)
}
